import { Divider, Typography, Grid } from "@mui/material";
import React from "react";

interface CategoryTitleProps {
    text: string,
    variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "subtitle1" | "subtitle2" | "body1" | "body2" | "caption" | "button" | "overline" | "inherit" | undefined,
    lined?: boolean,
    HeaderItem?: React.ReactNode
}

const CategoryTitle: React.FC<CategoryTitleProps> = ({
    text,
    variant,
    lined,
    HeaderItem,
}) => {
    return (
        <>
            <Grid container>
                <Grid item xs>
                    <Typography
                        component="h3"
                        variant={variant ? variant : "subtitle1"}
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, padding: "0.5em 1em", fontWeight: "bold" }}
                    >
                        {text}
                    </Typography>
                </Grid>
                {HeaderItem &&
                    <Grid item xs={12} sm={3}>
                        {HeaderItem}
                    </Grid>
                }
            </Grid>
            {lined &&
                <Divider sx={{mb: 1}} />
            }
        </>
    );
}

export default CategoryTitle